import { useState } from "react";
import { CopyIcon, CheckIcon } from "@phosphor-icons/react";
import { toast } from "sonner";

/**
 * Phase 15 — small inline copy-to-clipboard button.
 *
 * Pairs with any displayed ID, link, or reference value. On success, the
 * icon flashes a check for 1.4s and a sonner toast confirms the action.
 *
 *   <CopyButton value={customer.id} label="Customer ID" />
 */
export default function CopyButton({
  value,
  label,
  testId,
  size = 12,
  className = "",
}) {
  const [copied, setCopied] = useState(false);

  const onClick = async (e) => {
    e.stopPropagation();
    if (!value) return;
    try {
      await navigator.clipboard.writeText(String(value));
      setCopied(true);
      toast.success(label ? `${label} copied` : "Copied to clipboard");
      setTimeout(() => setCopied(false), 1400);
    } catch (err) {
      toast.error("Could not copy — clipboard unavailable");
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      title={label ? `Copy ${label}` : "Copy"}
      aria-label={label ? `Copy ${label}` : "Copy"}
      disabled={!value}
      className={`inline-flex h-5 w-5 items-center justify-center rounded text-slate-400 transition hover:bg-slate-100 hover:text-amber-600 focus:outline-none focus-visible:ring-1 focus-visible:ring-amber-500 disabled:opacity-30 ${className}`}
    >
      {copied ? (
        <CheckIcon size={size} weight="bold" className="text-emerald-600" />
      ) : (
        <CopyIcon size={size} weight="bold" />
      )}
    </button>
  );
}
